import React from 'react';

const CapTableContext = React.createContext({});

export default CapTableContext;
